import React, { useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import TimelineContext from '../context/TimelineContext'
import HeaderContext from '../context/HeaderContext'
import { get, patch, post } from 'aws-amplify/api'
import { useAuth0 } from '@auth0/auth0-react'

const TimelineProvider = ({ children }) => {
  const { featureFlags } = useContext(HeaderContext)
  const { getIdTokenClaims } = useAuth0()
  const [searchParams] = useSearchParams()
  const [taskId, setTaskId] = useState(null)
  const timelineId = featureFlags?.timeline?.referenceId
  const [dataSubscription, setDataSubscription] = useState(null)

  const baseUrl = process.env.REACT_APP_API_BASE_URL

  useEffect(() => {
    setTaskId(searchParams.get('task_id'))
  }, [searchParams])

  const getDataTask = async () => {
    const idToken = await getIdTokenClaims()
    if (taskId) {
      try {
        const resp = get({
          apiName: baseUrl,
          path: `/api/v3/timelines/${timelineId}/tasks/${taskId}`,
          options: {
            headers: {
              'content-type': 'application/json',
              Authorization: `Bearer ${idToken.__raw}`
            }
          }
        })
        const { body } = await resp.response
        const data = await body.json()
        return data
      } catch (error) {
        console.log(error)
      }
    }
  }

  const hideDataTask = async (id) => {
    const idToken = await getIdTokenClaims()
    if (id) {
      try {
        const resp = patch({
          apiName: baseUrl,
          path: `/api/v3/timelines/${timelineId}/tasks/${id}`,
          options: {
            headers: {
              'content-type': 'application/json',
              Authorization: `Bearer ${idToken.__raw}`
            },
            body: {}
          }
        })
        const { body } = await resp.response
        const data = await body.json()
        return data.data
      } catch (error) {
        console.log(error)
      }
    }
  }

  const getDataTimeline = async ({ timelineId, quarter, page }) => {
    const idToken = await getIdTokenClaims()
    try {
      const queryParams = new URLSearchParams()
      queryParams.append('timeline_id', timelineId)
      if (quarter !== undefined) queryParams.append('quarter', quarter)
      if (page !== undefined) queryParams.append('page', page)

      const pathWithParams = `/api/v3/timelines/?${queryParams.toString()}`

      const resp = get({
        apiName: baseUrl,
        path: pathWithParams,
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data
    } catch (error) {
      console.log('TimelineProvider getDataTimeline error:', error)
    }
  }

  const getUrlVideo = async (isMembership, idMembership, keySource) => {
    const idToken = await getIdTokenClaims()
    try {
      const queryParams = new URLSearchParams()
      queryParams.append('is_membership', isMembership)
      queryParams.append('id_membership', idMembership)
      queryParams.append('key_source', keySource)

      const pathWithParams = `/api/v2/assets?${queryParams.toString()}`

      const resp = get({
        apiName: baseUrl,
        path: pathWithParams,
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data
    } catch (error) {
      console.log(error)
    }
  }

  const getPatientsSubscriptions = async () => {
    const idToken = await getIdTokenClaims()
    if (idToken) {
      try {
        const resp = get({
          apiName: baseUrl,
          path: '/api/v2/patients/subscriptions',
          options: {
            headers: {
              'content-type': 'application/json',
              Authorization: `Bearer ${idToken.__raw}`
            }
          }
        })
        const { body } = await resp.response
        const data = await body.json()
        return data.data
      } catch (error) {
        console.log(error)
      }
    }
  }

  const getMembershipDetails = async ({ isDesktop }) => {
    const idToken = await getIdTokenClaims()
    if (idToken) {
      try {
        const queryParams = new URLSearchParams()
        queryParams.append('is_desktop', isDesktop)

        const pathWithParams = `/api/v2/memberships?${queryParams.toString()}`

        const resp = get({
          apiName: baseUrl,
          path: pathWithParams,
          options: {
            headers: {
              'content-type': 'application/json',
              Authorization: `Bearer ${idToken.__raw}`
            }
          }
        })
        const { body } = await resp.response
        const data = await body.json()
        return data.data
      } catch (error) {
        console.log(error)
      }
    }
  }

  const postSubscription = async () => {
    const idToken = await getIdTokenClaims()
    try {
      const resp = post({
        apiName: baseUrl,
        path: '/api/v2/subscriptions',
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`,
            'Request-Channel': 'app-web'
          },
          body: {
            priceStripeId:
              dataSubscription?.priceStripeId ||
              window.localStorage.getItem('priceStripeId')
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data
    } catch (error) {
      console.log(error)
    }
  }

  const getSetupIntent = async () => {
    const idToken = await getIdTokenClaims()
    try {
      const queryParams = new URLSearchParams()
      queryParams.append('price_stripe_id', dataSubscription.priceStripeId)

      const pathWithParams = `/api/v2/setup-intent?${queryParams.toString()}`

      const resp = get({
        apiName: baseUrl,
        path: pathWithParams,
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <TimelineContext.Provider
      value={{
        task_id: taskId,
        taskId,
        setTaskId,
        getDataTask,
        getDataTimeline,
        getUrlVideo,
        getPatientsSubscriptions,
        getMembershipDetails,
        postSubscription,
        getSetupIntent,
        timelineId,
        dataSubscription,
        setDataSubscription,
        hideDataTask
      }}
    >
      {children}
    </TimelineContext.Provider>
  )
}

export default TimelineProvider
